<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.resume.resume')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :footer="total"
        :selectAll="false"
        :action="false"
        :items="resumeData"
        :headers="headers"
        :search="search"
        :wrap="true"
        :hideActions="true"
      ></data-table>
    </v-card>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable";
export default {
  name: "Resume",
  components: {
    DataTable
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: this.$t('companiesSettings.level'),
          align: 'center',
          value: 'level'
        },
        {
          text: this.$t('companiesSettings.name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('inGame.companies.playerName'),
          align: 'center',
          value: 'playerName'
        },
        {
          text: this.$t('inGame.resume.averageRequestQuantity'),
          align: 'center',
          value: 'averageRequestQuantity'
        },
        {
          text: this.$t('inGame.resume.averageOrderQuantity'),
          align: 'center',
          value: 'averageOrderQuantity'
        },
        {
          text: this.$t('inGame.resume.range'),
          align: 'center',
          value: 'range'
        },
        {
          text: this.$t('inGame.resume.otd'),
          align: 'center',
          value: 'otd'
        },
        {
          text: this.$t('inGame.resume.delaysDepth'),
          align: 'center',
          value: 'delaysDepth'
        },
        {
          text: this.$t('inGame.resume.averageStock'),
          align: 'center',
          value: 'averageStock'
        },
        {
          text: this.$t('inGame.resume.stockCost'),
          align: 'center',
          value: 'stockCost'
        },
        {
          text: this.$t('inGame.resume.delayCost'),
          align: 'center',
          value: 'delayCost'
        },
        {
          text: this.$t('inGame.resume.cost'),
          align: 'center',
          value: 'cost'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    customToFixed (val) {
      if ((val % 1) != 0) {
        return val.toFixed(1)
      } else {
        return val
      }
    }
  },
  computed: {
    resumeData () {
      return this.$store.state.games.current ? this.$store.state.games.current.companies.map((company) => { 
        if (company.assignable) {
          return {
            level: company.level,
            name: company.name,
            playerName: company.playerName,
            averageRequestQuantity: this.customToFixed(company.data.resume.averageRequestQuantity),
            averageOrderQuantity: this.customToFixed(company.data.resume.averageOrderQuantity),
            range: this.customToFixed(company.data.resume.range),
            otd: this.customToFixed(company.data.resume.otd * 100) + '%',
            delaysDepth: this.customToFixed(company.data.resume.delaysDepth),
            averageStock: this.customToFixed(company.data.resume.averageStock),
            stockCost: this.customToFixed(company.data.resume.stockCost),
            delayCost: this.customToFixed(company.data.resume.delayCost),
            cost: this.customToFixed(company.data.resume.cost)
          }
        } else {
          return {
              level: company.level,
              name: company.name,
              playerName: company.playerName,
              averageOrderQuantity: this.customToFixed(company.data.resume.averageOrderQuantity),
              range: company.data.resume.range,
              otd: "",
              delaysDepth: "",
              averageStock: "",
              stockCost: "",
              delayCost: "",
              cost: ""
            }
        }
      }) : [] 
    },
    total () {
      if (!this.$store.state.games.current) return {}
      let res = this.$store.state.games.current.companies.reduce((prev, curr) => {
        prev.averageGuestDemand += curr.data.resume.averageRequestQuantity
        prev.averageOrderQuantity += curr.data.resume.averageOrderQuantity
        prev.range += curr.data.resume.range
        prev.otd += curr.data.resume.otd * 100
        prev.delaysDepth += curr.data.resume.delaysDepth
        prev.averageStock += curr.data.resume.averageStock
        prev.stockCost += curr.data.resume.stockCost
        prev.delayCost += curr.data.resume.delayCost
        prev.cost += curr.data.resume.cost
        return prev
      }, {
        averageGuestDemand: 0,
        averageOrderQuantity: 0,
        range: 0,
        otd: 0,
        delaysDepth: 0,
        averageStock: 0,
        stockCost: 0,
        delayCost: 0,
        cost: 0,
      })
      res.averageGuestDemand = this.customToFixed(res.averageGuestDemand / this.$store.getters["games/assignableCompanies"].length)
      res.averageOrderQuantity = this.customToFixed(res.averageOrderQuantity / this.$store.state.games.current.companies.length)
      res.range = this.customToFixed(res.range / this.$store.state.games.current.companies.length)
      res.otd = this.customToFixed(res.otd / this.$store.getters["games/assignableCompanies"].length) + "%"
      res.delaysDepth = this.customToFixed(res.delaysDepth / this.$store.getters["games/assignableCompanies"].length)
      res.averageStock = this.customToFixed(res.averageStock / this.$store.getters["games/assignableCompanies"].length)
      res.stockCost = this.customToFixed(res.stockCost)
      res.delayCost = this.customToFixed(res.delayCost)
      res.cost = this.customToFixed(res.cost)

      return res
    }
  }
};
</script>
